import css from './PostSection.module.scss';
import classNames from 'classnames';
import Container from '../container/Container';
import H1title from '../titles/H1title';
import i18n from 'i18next';

export default function PostSection({id, metadata}) {
  const lang = i18n.language === 'en' ? 'en' : 'ru';
  const heroSrc = metadata.heroImage
    ? `/blog/${id}/${lang}/${metadata.heroImage}`
    : `/blog/${id}/${lang}/img.png`;

  return (
    <>
      <section className={classNames(css.section, css.blogPostHead)}>
        <Container>
          <div className={css.mb60}>
            <div className={css.blogPostTitle}>
              <p className={css.blogTemplateDate}>{metadata.date}</p>
              <H1title isWhite={true} center={true}>{metadata.title}</H1title>
            </div>
          </div>
          <img loading="lazy" alt=""
               src={heroSrc}
               className={css.blogTemplateImage}/>
        </Container>
      </section>
    </>
  );
}